"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackLanguageSwitch = exports.trackNavigationElementOpen = exports.NavigationTarget = void 0;
const libs_tracking_events_1 = require("@hotelplan/libs.tracking-events");
var NavigationTarget;
(function (NavigationTarget) {
    NavigationTarget["WISHLIST"] = "wishlist";
    NavigationTarget["ACCOUNT"] = "account";
    NavigationTarget["CONTACT"] = "contact";
    NavigationTarget["HISTORY"] = "history";
    NavigationTarget["SHARING"] = "sharing";
})(NavigationTarget || (exports.NavigationTarget = NavigationTarget = {}));
const trackNavigationElementOpen = (target) => (0, libs_tracking_events_1.track)({
    event: `🚀 click.open`,
    eventMetadata: {
        source: 'header',
        target,
        component: 'menu-icons',
    },
    _clear: true,
});
exports.trackNavigationElementOpen = trackNavigationElementOpen;
const trackLanguageSwitch = (target) => (0, libs_tracking_events_1.track)({
    event: `🚀 click.change`,
    eventMetadata: {
        source: 'header',
        target: target.toUpperCase(),
        component: 'language-switch',
    },
    _clear: true,
});
exports.trackLanguageSwitch = trackLanguageSwitch;
//# sourceMappingURL=trackHeaderNavigation.js.map